window.YappyHandlers = {
  onSuccess(e) {
    const info = e.detail;
    console.log("✅ Pago ok:", info);
    setTimeout(function () {
      location.reload();
    }, 3000);
  },
  onError(e) {
    const err = e.detail;
    console.error("❌ Pago falló:", err);
    setTimeout(function () {
      location.reload();
    }, 3000);
  }
};
